import { Link } from "react-router-dom";

// Show the banner from 1 October through 3 January (Copenhagen's Christmas season).
function isChristmasSeason(now = new Date()) {
  const month = now.getMonth() + 1; // 1-12
  const day = now.getDate();
  return month >= 10 || (month === 1 && day <= 3);
}

const TREE_IMG =
  "https://customer-assets-cm19k8pv.emergentagent.net/job_explore-copenhagen/artifacts/rn2xhl0i_2026-08-19%2000_54_54.578%2B0200.webp";

export const ChristmasBanner = () => {
  const inSeason = isChristmasSeason();

  return (
    <section data-testid="christmas-banner" className="bg-[#F9F8F6] py-6 md:py-10">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10">
        <Link
          to="/christmas"
          data-testid="christmas-banner-link"
          className="group grid lg:grid-cols-2 overflow-hidden rounded-2xl border border-black bg-[#7A1420] text-white shadow-brut hover:-translate-y-1 hover:shadow-brut-lg transition-all"
        >
          <div className="relative aspect-[16/9] lg:aspect-auto lg:min-h-[320px] overflow-hidden">
            <img
              src={TREE_IMG}
              alt="The big Christmas tree lit up on Rådhuspladsen, Copenhagen"
              loading="lazy"
              className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
            />
          </div>
          <div className="p-7 md:p-12 flex flex-col justify-center">
            <p className="font-body font-800 text-[11px] tracking-[0.3em] eyebrow text-white">
              {inSeason ? "THE SEASONAL GUIDE" : "WORTH PLANNING AROUND"}
            </p>
            <p className="font-display font-900 tracking-tighter leading-[0.95] text-4xl md:text-5xl mt-3">
              Christmas in <span className="font-editorial italic font-600">Copenhagen</span>
            </p>
            <p className="font-body text-sm md:text-base text-white/80 mt-4 leading-relaxed max-w-md">
              {inSeason
                ? "Markets on the old squares, gløgg in every hand, J-Day, the Lucia kayaks and a million lights — every street worth wandering."
                : "The markets, the gløgg and a million lights are worth planning a whole trip around — here's the full guide."}
            </p>
            <span className="mt-6 self-start inline-flex items-center gap-2 font-display font-900 text-base bg-white text-[#7A1420] px-6 py-3 rounded-full transition-colors">
              See the Christmas guide
            </span>
          </div>
        </Link>
      </div>
    </section>
  );
};
